import React, { FC, useState, useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import Card from '../components/card.component';
import { cloneDeep } from 'lodash';

const useStyles = makeStyles(theme => ({
  marginFix: {
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2)
  },
  active: {
    backgroundColor: '#'
  }
}));

interface Props {
  cards: string[];
  players: string[];
  handlePyramidOpen: (card: string) => void;
  enableBus: (bus: boolean) => void;
}

const Pyramid: FC<Props> = (props) => {

  const { cards, handlePyramidOpen, enableBus, players } = props;


  const [deSjaak] = useState(players[Math.floor(Math.random() * players.length)])

  const [state, setState] = useState(() => {

    return ({
      cards: cards.map((c, idx) => ({ card: c, open: false, idx: idx }))
    });
  })

  const classes = useStyles(props);

  const handleClick = (idx: number) => () => {
    const card = state.cards[idx].card;
    handlePyramidOpen(card);
    const copy = cloneDeep(state);
    copy.cards[idx].open = true;
    setState(copy);
  }

  useEffect(() => {
    const left = state.cards.findIndex(c => !c.open);
    enableBus(left === -1);
  }, [state, enableBus])

  return (
    <Grid container direction="column">
      <Grid item container justify="center" spacing={2} className={classes.marginFix}>
        <Grid item>
          Vijf slokken
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(0)}
            card={state.cards[0].card}
            open={state.cards[0].open}
          />
        </Grid>
      </Grid>

      <Grid item container justify="center" spacing={2} className={classes.marginFix}>
        <Grid item>
          Vier slokken
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(1)}
            card={state.cards[1].card}
            open={state.cards[1].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(2)}
            card={state.cards[2].card}
            open={state.cards[2].open}
          />
        </Grid>
      </Grid>

      <Grid item container justify="center" spacing={2} className={classes.marginFix}>
        <Grid item>
          Drie slokken
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(3)}
            card={state.cards[3].card}
            open={state.cards[3].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(4)}
            card={state.cards[4].card}
            open={state.cards[4].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(5)}
            card={state.cards[5].card}
            open={state.cards[5].open}
          />
        </Grid>
      </Grid>

      <Grid item container justify="center" spacing={2} className={classes.marginFix}>
        <Grid item>
          <span>Twee slokken</span>
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(6)}
            card={state.cards[6].card}
            open={state.cards[6].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(7)}
            card={state.cards[7].card}
            open={state.cards[7].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(8)}
            card={state.cards[8].card}
            open={state.cards[8].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(9)}
            card={state.cards[9].card}
            open={state.cards[9].open}
          />
        </Grid>
      </Grid>

      <Grid item container justify="center" spacing={2} className={classes.marginFix}>
        <Grid item>
          Één slok
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(10)}
            card={state.cards[10].card}
            open={state.cards[10].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(11)}
            card={state.cards[11].card}
            open={state.cards[11].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(12)}
            card={state.cards[12].card}
            open={state.cards[12].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(13)}
            card={state.cards[13].card}
            open={state.cards[13].open}
          />
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(14)}
            card={state.cards[14].card}
            open={state.cards[14].open}
          />
        </Grid>
      </Grid>

      <Grid item container justify="center" spacing={2} className={classes.marginFix}>
        <Grid item>
          <span>Adtje {deSjaak}</span>
        </Grid>
        <Grid item>
          <Card
            onClick={handleClick(15)}
            card={state.cards[15].card}
            open={state.cards[15].open}
          />
        </Grid>
      </Grid>

    </Grid >
  )
}

export default Pyramid;
